import { render, staticRenderFns } from "./answer.vue?vue&type=template&id=1125cda3&scoped=true"
import script from "./answer.vue?vue&type=script&lang=js"
export * from "./answer.vue?vue&type=script&lang=js"
import style0 from "./answer.vue?vue&type=style&index=0&id=1125cda3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1125cda3",
  null
  
)

export default component.exports